import { Goal, MetricEntry, MetricEntryMode, Task } from '@griply/types';
import { startOfDay } from 'date-fns';

import { formatDateKey } from './format-date-key';

export type ComputeGoalTaskProgressOptions = {
  goal: Goal;
  completedTasks: Task[];
  allTaskCount: number;
};

export type ComputeGoalTaskProgressResult = {
  entries: MetricEntry[];
  target: number;
};

export const computeGoalTaskProgress = ({
  goal,
  completedTasks,
  allTaskCount,
}: ComputeGoalTaskProgressOptions): ComputeGoalTaskProgressResult => {
  const target = allTaskCount;

  const dateTasksMap = completedTasks
    .filter(({ completedAt }) => completedAt)
    .reduce<Record<string, MetricEntry>>(
      (acc, { completedAt }, currentIndex) => {
        const dateKey = formatDateKey(completedAt!);
        acc[dateKey] = acc[dateKey] ?? {
          id: dateKey,
          date: startOfDay(completedAt!),
          value: 0,
          mode: MetricEntryMode.Absolute,
        };
        acc[dateKey].value = currentIndex + 1;

        return acc;
      },
      {},
    );

  const goalStartDate = startOfDay(goal.startDate ?? goal.createdAt);

  const entries: MetricEntry[] = [
    {
      id: formatDateKey(goalStartDate),
      date: goalStartDate,
      value: 0,
      mode: MetricEntryMode.Absolute,
    },
    ...Object.values(dateTasksMap),
  ];

  return { entries, target };
};
